// @ts-expect-error - imported from .js/.jsx file
import {EyeSlashIcon} from 'shells/icon/svg/eye-slash-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LockedIcon} from 'shells/icon/svg/locked-icon';
// @ts-expect-error - imported from .js/.jsx file
import {UnlockIcon} from 'shells/icon/svg/unlock-icon';

import type {SpamPreventionType} from 'nutshell-graphql-types';

export function getSpamPreventionTitle(spamPreventionType: SpamPreventionType) {
    switch (spamPreventionType) {
        case 'SPAM_PREVENTION_MOSTLY_INVISIBLE':
            return 'Mostly invisible (Recommended)';
        case 'SPAM_PREVENTION_ALWAYS_ON':
            return 'Always on';
        case 'SPAM_PREVENTION_OFF':
        default:
            return 'No spam protection';
    }
}

export function getSpamPreventionDescription(spamPreventionType: SpamPreventionType) {
    switch (spamPreventionType) {
        case 'SPAM_PREVENTION_MOSTLY_INVISIBLE':
            return 'Only show a captcha to suspected spammers';
        case 'SPAM_PREVENTION_ALWAYS_ON':
            return 'Always show a captcha to every submitter';
        case 'SPAM_PREVENTION_OFF':
        default:
            return 'Accept every submission and don’t try to prevent spam';
    }
}

export function getSpamPreventionIcon(spamPreventionType: SpamPreventionType) {
    switch (spamPreventionType) {
        case 'SPAM_PREVENTION_MOSTLY_INVISIBLE':
            return EyeSlashIcon;
        case 'SPAM_PREVENTION_ALWAYS_ON':
            return LockedIcon;
        case 'SPAM_PREVENTION_OFF':
        default:
            return UnlockIcon;
    }
}
